<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">导出科室收支项目模版</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="padding: 10px;">

        <div>
          <div style="float:left;">
            <el-input size="mini" placeholder="输入科室名称" v-model="name" clearable style="margin:0 5px;width:150px"></el-input>
            <el-button size="mini" type="primary" plain icon="el-icon-search" @click="getList(true)">查询</el-button>
          </div>
          <div style="clear:both;"></div>
        </div>


        <div style="height: 10px;"></div>

        <el-table class="table" size="mini" :data="tableData" v-loading="loading" border :height="300">
          <el-table-column label="科室" prop="name"></el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini" @click.native.prevent="handleSelect(scope.$index, scope.row)">导出收入模版</el-button>
              <el-button type="primary" plain size="mini" @click.native.prevent="handleSelect2(scope.$index, scope.row)">导出支出模版</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="page" style="padding: 5px;">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                           background
                           layout="prev, pager, next"
                           :total="totalItems"
                           :page-size="20"
                           :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'ElderlyGov',
  data() {
    return {

      loading: false,

      name:'',

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      th:this.$store.state.tableHeight,
    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  methods: {
    init(){
      this.getList()
    },
    closeSelf() {
      this.$emit("closeDepartment");
    },


    handleSelect(index, row) {
      this.$emit("setDepartment",row);
      this.closeSelf();
    },
    handleSelect2(index, row) {
      this.$emit("setDepartment2",row);
      this.closeSelf();
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){

      if(isSearch)this.currentPage = 1;

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Department/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          name:this.name,
        }
      }).then((response) => {
        this.loading = false;

        if (response.data.error == 0) {
          this.tableData=response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }

      })
    },


  }
}


</script>

<style lang="scss" scoped>

</style>
